import Placeholder from '../../../@common/components/details/Placeholder';
import ViewContainer from './components/ViewContainer';
import useSelect from '../../store/hooks/useSelect';
import useLocal from '../../../../store/local/hooks/useLocal';

export default () => {
  const { renderDefault } = useSelect();
  const { text } = useLocal();

  if (renderDefault) return <Placeholder placeholder={text.pages.details.defaultText} />;

  return <ViewContainer />;
};
